// External applications linked from the dashboard (sidebar Apps dropdown and
// the Workflows ▸ Apps card). They are NOT part of this React app — each is
// opened in a new browser tab.
//
// Tool Tracker (separate Flask app):
//   • Local dev: falls back to http://localhost:5000 (run `python app.py` in
//     the ToolTracker project; it must be running for the link to work).
//   • Production: set REACT_APP_TOOLTRACKER_URL in .env.production to the
//     server address (e.g. http://<server>:5000) before `npm run build`.
export const TOOLTRACKER_URL =
  process.env.REACT_APP_TOOLTRACKER_URL || "http://localhost:5000";

/** Opens an external app in a new tab without giving it access to this window. */
export const openExternalApp = (url) => {
  window.open(url, "_blank", "noopener,noreferrer");
};
